import React from "react";
import { TermController } from "../../core/config/controllers/TermController";
import { DateHelper } from "../../core/config/helpers/DateHelper";

export default function Terms() {
    const [terms, setTerms] = React.useState([]);

    React.useEffect(() => {
        loadTerms();
    }, []);

    function loadTerms() {
        TermController.List((result) => {
            if (result && result.length > 0) {
                setTerms(result);
            } else {

            }
        });
    }

    return (
        <div className="content">
            <h1 className="content-heading">Termos e Condições</h1>
            {terms && terms.map((term, index) => (

                <div className="block block-rounded block-bordered">
                    <div className="block-header">
                        <div className="block-title">{term.name}</div>
                        <div className="block-tools">{DateHelper.DateTranslate(term.updated_at)}</div>
                    </div>
                    <div className="block-content" style={{ whiteSpace: "pre-line" }}>
                        {term.content}
                    </div>
                </div>
            ))}
        </div>
    )
}